const SESSION_1_HOUR = 8
const SESSION_2_HOUR = 12
const SESSION_1_NAME = 'Session 1'
const SESSION_2_NAME = 'Session 2'

/**
* Extracts the local hour value from an ISO datetime string and uses that hour to
* determine the session name.
* @param {string} dateTimeString - ISO 8601 datetime with timezone (e.g., '2026-11-02T08:00-04:00')
* @returns {number} The hour value (0-23) from the local time portion
*/
const useExamSession = examDateTime => {
  // Extract just the time portion before the timezone offset
  const timeMatch = examDateTime?.match(/T(\d{2}):/)
  const examHour = timeMatch ? parseInt(timeMatch[1], 10) : 0
  const sessionName =
    examHour === SESSION_1_HOUR
      ? SESSION_1_NAME
      : examHour === SESSION_2_HOUR
        ? SESSION_2_NAME
        : ''
  return sessionName
}

export default useExamSession